import { computed } from 'vue';
import { ComposerTranslation } from 'vue-i18n';
import { ChipStyle } from './dispo-constants';

export const NonFoodMenuPaths = {
  LogisticPlanner: '/non-food/logistic-planner',
  DispoWeeks: '/non-food/logistic-planner/dispo-weeks',
  DispoWeekDetails: '/non-food/logistic-planner/dispo-week-details',
  Changes: '/non-food/changes',
  ImportFeedback: '/non-food/import-feedback',
} as const;

// logistic planner tabs
export const LogisticPlannerTabs = {
  all: 'tab-all',
  inProgress: 'tab-in-progress',
  completed: 'tab-completed',
} as const;

// Bearbeitungsstatus
export const ProcessingStatus = {
  inProgress: 'in-progress',
  completed: 'completed',
};

// Verteilungsart
export enum DistributionType {
  PERCENT = 1,
  CARTON = 2,
}

export interface DispoItemStatusChipData {
  statusId: number;
  style: ChipStyle;
}

export const DispoItemStatus = {
  ADD: {
    id: 1,
    name: 'ADD',
  },
  RES: {
    id: 2,
    name: 'RES',
  },
  REC: {
    id: 3,
    name: 'REC',
  },
  OPT: {
    id: 4,
    name: 'OPT',
  },
  RTS: {
    id: 5,
    name: 'RTS',
  },
  RDY: {
    id: 6,
    name: 'RDY',
  },
  CHR: {
    id: 7,
    name: 'CHR',
  },
  CHA: {
    id: 8,
    name: 'CHA',
  },
} as const;

const dispoItemStatusMapEntries: [string, DispoItemStatusChipData][] = [
  [
    DispoItemStatus.ADD.name,
    {
      statusId: DispoItemStatus.ADD.id,
      style: { backgroundColor: '#77BCED', fontColor: '#464646' },
    },
  ],
  [
    DispoItemStatus.RES.name,
    {
      statusId: DispoItemStatus.RES.id,
      style: { backgroundColor: '#0079CE', fontColor: '#FFFFFF' },
    },
  ],
  [
    DispoItemStatus.REC.name,
    {
      statusId: DispoItemStatus.REC.id,
      style: { backgroundColor: '#0C4D7A', fontColor: '#FFFFFF' },
    },
  ],
  [
    DispoItemStatus.OPT.name,
    {
      statusId: DispoItemStatus.OPT.id,
      style: { backgroundColor: '#0CC2CE', fontColor: '#FFFFFF' },
    },
  ],
  [
    DispoItemStatus.RTS.name,
    {
      statusId: DispoItemStatus.RTS.id,
      style: { backgroundColor: '#B2D6F0', fontColor: '#464646' },
    },
  ],
  [
    DispoItemStatus.RDY.name,
    {
      statusId: DispoItemStatus.RDY.id,
      style: { backgroundColor: '#72CB94', fontColor: '#464646' },
    },
  ],
  [
    DispoItemStatus.CHR.name,
    {
      statusId: DispoItemStatus.CHR.id,
      style: { backgroundColor: '#0CC2CE', fontColor: '#FFFFFF' },
    },
  ],
  [
    DispoItemStatus.CHA.name,
    {
      statusId: DispoItemStatus.CHA.id,
      style: { backgroundColor: '#0CC2CE', fontColor: '#FFFFFF' },
    },
  ],
] as const;
export const DispoItemStatusChipDataMap = new Map<string, DispoItemStatusChipData>(dispoItemStatusMapEntries);

export type DispoItemStatusType = (typeof dispoItemStatusMapEntries)[number][0];

export interface StatusChipDetails {
  statusLabel: string;
  style: ChipStyle;
  tooltipText: string;
}

export function getStatusChipDetails(t: ComposerTranslation, nfDispoItemStatusId: number): StatusChipDetails {
  let nfDispoItemStatus = '';
  DispoItemStatusChipDataMap.forEach((chipData, statusValue) => {
    if (chipData.statusId == nfDispoItemStatusId) {
      nfDispoItemStatus = statusValue;
    }
  });
  const statusStyle = DispoItemStatusChipDataMap.get(nfDispoItemStatus as DispoItemStatusType)?.style as ChipStyle;
  const tooltipText = computed(() =>
    t(
      `pages.nonFood.logisticPlanner.dispoOptimization.statusHistory.statusDescriptions.${nfDispoItemStatus.toLowerCase()}`
    )
  );
  return {
    statusLabel: nfDispoItemStatus,
    style: statusStyle,
    tooltipText: tooltipText.value,
  };
}
